import algoliasearch from 'algoliasearch/lite'
import globals from '../../utils/globals'
import { Component } from 'preact'
import { getSearchToken, Credentials } from '../../services/algoliaService'

export default abstract class<P = {}, S = {}> extends Component<P, S> {
  algoliaIndex: algoliasearch.Index

  protected constructor (props?: P) {
    super(props)
    this.cb = this.cb.bind(this)
  }

  cb (data: Credentials) {
    const client = algoliasearch(data.client_id, data.token)
    this.algoliaIndex = client.initIndex(globals('communityId'))
  }

  async componentDidMount () {
    await getSearchToken(this.cb)
  }
}
